import { Component } from '@angular/core';
import { VideoPlayerDialog } from '../../home/home.component';
import { MatDialog } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-exclusive-cat',
  templateUrl: './exclusive-cat.component.html',
  styleUrls: ['./exclusive-cat.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class ExclusiveCatComponent {

  Sessionslist:any[] =[
    {
      step:'STEP 1',
      img:'https://media.iquanta.in/ui_images/new-home/Video_1-small.webp',
      title:'CAT 2025 Strategy & Details',
      url:'WdfI4nFkc_A'
    },
    {
      step:'STEP 2',
      img:'https://media.iquanta.in/ui_images/new-home/Video_2-small.webp',
      title:'CAT Geometry Problem Solving',
      url:'2fQjVb2GiQ4'
    },
    {
      step:'STEP 3',
      img:'https://media.iquanta.in/ui_images/new-home/Video_3-small.webp',
      title:'CAT LRDI Set Solving',
      url:'jXWzDqGDu0Q'
    },
    {
      step:'STEP 4',
      img:'https://media.iquanta.in/ui_images/new-home/Video_4-small.webp',
      title:'CAT RC Set Solving',
      url:'JGcoLNAYc_Y'
    },
    {
      step:'STEP 5',
      img:'https://media.iquanta.in/ui_images/new-home/Video_5-small.webp',
      title:'iQuanta iBrahma Playlist',
      url:'https://www.youtube.com/watch?v=qwt0nejoV-o&list=PL4YW4OWyzRDTSmSbpN93y1dNu8DhKNaAt'
    }
  ]

  constructor(public dialog: MatDialog){}

  playVideo(obj: any, ind:any) {
    if(ind != 4){
      const dialogref = this.dialog.open(VideoPlayerDialog, {
        width: '800px',
        data: { video: 'https://www.youtube.com/embed/' + obj + '?rel=0', type: 'toppers' },
        panelClass: ['video-dialog', 'video-dilogue2']
      })
      dialogref.afterClosed().subscribe(result => {
  
      })
    }else{
      window.open(obj, '_blank')
    }
   
  }

}
